import { memo, useCallback } from 'react'

import { AnimatePresence, LayoutGroup } from 'framer-motion'

import { useChatRefs } from '@/contexts/ChatRefs/useChatRefs'
import { useApi } from '@/hooks/useApi'
import { useCurrentConversationStore } from '@/store/useCurrentConversationStore'

import { AgentMessage } from './AgentMessage'
import { UserMessage } from './MessageComponents'

export const ChatMessagesList = memo(
  function ChatMessagesList({ messages }) {
    const { setLastAgentMessageRef } = useChatRefs()
    const streamPhase = useCurrentConversationStore(state => state.streamPhase)
    const isStreaming = streamPhase === 'streaming' || streamPhase === 'loading'
    const getMessageByClientId = useCurrentConversationStore(
      s => s.getMessageByClientId,
    )
    const updateMessage = useCurrentConversationStore(s => s.updateMessage)
    const api = useApi()
    const handleUpdateMessage = useCallback(
      async (clientId, body) => {
        const { id: messageId } = getMessageByClientId(clientId) ?? {}
        if (messageId) {
          const { body: updatedMessage } = await updateMessage(
            api,
            messageId,
            body,
          )

          return updatedMessage
        }
        throw new Error('Message ID not found')
      },
      [api, getMessageByClientId, updateMessage],
    )
    const lastAgentIdx = [...messages]
      .reverse()
      .findIndex(m => m.role === 'assistant')
    const latestAgentIdx =
      lastAgentIdx === -1 ? -1 : messages.length - 1 - lastAgentIdx
    return (
      <LayoutGroup initial={false} id="messages">
        <AnimatePresence initial={false}>
          {messages.map((message, index) => {
            if (message.role === 'assistant') {
              const isLast = index === latestAgentIdx
              return (
                <AgentMessage
                  handleUpdateMessage={handleUpdateMessage}
                  key={message.clientId}
                  clientId={message.clientId}
                  isStreaming={isStreaming && isLast}
                  content={message.content ?? ''}
                  meta={message.meta ?? {}}
                  selectedVersion={message?.selected_version ?? 'standard'}
                  setLastAgentMessageRef={
                    isLast ? setLastAgentMessageRef : undefined
                  }
                />
              )
            }
            return (
              <UserMessage clientId={message.clientId} key={message.clientId}>
                {message.content}
              </UserMessage>
            )
          })}
          {/* <div className="h-32" /> */}
        </AnimatePresence>
      </LayoutGroup>
    )
  },
  (prev, next) => prev.messages === next.messages,
)

export default ChatMessagesList
